import {
    SET_TRANSFER_ORDER_BY_ID
} from "./TransferOrderByIdType";

const initialState = {
    transferOrderByIdData: []
}

const reducer = (state = initialState, action: any) => {
    if(action.type === SET_TRANSFER_ORDER_BY_ID) {
        return {
            ...state,
            transferOrderByIdData: action.transferOrderByIdData,
        };
    }else{
    return state;
    }
};

export default reducer;
